import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import auth from 'lib/authentication';
import { getParameterByName } from 'helpers/url';
import { Spinner } from 'components/UI';
import { Button, translate } from '@haldor/ui';
var Login = /*#__PURE__*/function (_Component) {
  function Login(props) {
    var _this;
    _classCallCheck(this, Login);
    _this = _callSuper(this, Login, [props]);
    _defineProperty(_this, "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var nextUrl;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            nextUrl = '/';
            if (getParameterByName('nextUrl') != null) {
              nextUrl = getParameterByName('nextUrl');
            }
            if (getParameterByName('idp') != null) {
              _this.setState({
                loading: true
              });

              // Login with additional config
              auth.login({
                extraQueryParameters: {
                  'acr_values': 'idp:' + getParameterByName('idp')
                }
              });
            }
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "onClick", function () {
      auth.login();
    });
    _this.state = {
      loading: false
    };
    return _this;
  }
  _inherits(Login, _Component);
  return _createClass(Login, [{
    key: "render",
    value: function render() {
      var translate = this.props.translate;
      if (this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "login-content"
      }, /*#__PURE__*/React.createElement("h1", null, translate('An efficient and accessible learning platform')), /*#__PURE__*/React.createElement("p", {
        className: "login-content__subtitle"
      }, translate('Welcome to Haldor')), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.onClick
      }, translate('Log in')), /*#__PURE__*/React.createElement("p", {
        className: "login-content__helptext"
      }, translate('Experiencing problems signing in? Contact your school.')));
    }
  }]);
}(Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    deviceInfo: state.DeviceInfo,
    translate: translate(state.Languages.translations)
  };
};
export default withRouter(connect(mapStateToProps)(Login));